import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { guestGuard } from './core/guards/guest.guard';
import { roleGuard } from './core/guards/role.guard';
import { UserRole } from './core/models/user.model';
import { LayoutComponent } from './components/layout/layout.component';

export const routes: Routes = [
  { path: '', redirectTo: 'auth', pathMatch: 'full' },
  {
    path: 'auth',
    canActivate: [guestGuard],
    loadComponent: () => import('./components/login/login').then((c) => c.LoginComponent),
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      // Front-office (User && Admin)
      {
        path: 'home',
        canActivate: [roleGuard(UserRole.USER, UserRole.ADMIN, UserRole.ADMIN_SUPPORT)],
        loadChildren: () =>
          import('./front-office/front-office-routing-module').then(
            (m) => m.FrontOfficeRoutingModule,
          ),
      },
      // Back-office (Super Admin && Admin)
      {
        path: 'admin',
        canActivate: [
          roleGuard(
            UserRole.SUPER_ADMIN,
            UserRole.ADMIN,
            UserRole.ADMIN_SUPPORT,
            UserRole.COMMERCIAL,
          ),
        ],
        loadChildren: () =>
          import('./back-office/back-office-routing-module').then((m) => m.BackOfficeRoutingModule),
      },
      // Common Pages
      {
        path: 'profile',
        loadComponent: () => import('./components/profile/profile').then((c) => c.ProfileComponent),
      },
    ],
  },
  {
    path: 'forget-password',
    loadComponent: () =>
      import('./components/forget-password/forget-password').then((c) => c.ForgetPassword),
  },
  {
    path: 'reset-password/:token',
    loadComponent: () =>
      import('./components/reset-password/reset-password').then((c) => c.ResetPassword),
  },
  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'info/:type',
        loadComponent: () => import('./components/info/info').then((c) => c.InfoComponent),
      },
    ],
  },
  {
    path: 'registration',
    loadComponent: () =>
      import('./components/registration/registration').then((c) => c.Registration),
  },
  { path: '**', redirectTo: 'auth' },
];
